import { Component } from '@verndale/core'

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $titleContainers: this.el.querySelectorAll('.featured-card__title')
    }
    this.setupTitlesHeight()
  }

  addListeners() {
    window.addEventListener('resize', this.setupTitlesHeight.bind(this))
  }

  getAllContainersHeight() {
    const containersHeight = Array.from(this.dom.$titleContainers).map(
      (titleContainer) => titleContainer.offsetHeight
    )
    return containersHeight
  }

  cleanHeight(){
    Array.from(this.dom.$titleContainers).map((title) => {
      if (title.hasAttribute('style')) {
        title.setAttribute('style', '')
      }
    })
  }

  setupTitlesHeight() {
    this.cleanHeight();
    const containersHeight = this.getAllContainersHeight();
    const maxHeight = containersHeight.sort()[containersHeight.length - 1]

    Array.from(this.dom.$titleContainers).map((title) => {
      title.style.minHeight = `${maxHeight}px`
    })
  }
}

export default Module
